import React from 'react';

const facebookPage = 'https://www.facebook.com/ICAST.Pakistan';
const facebookEmbed = `https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(facebookPage)}&tabs=timeline&width=500&height=620&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true`;

const ICASESocialFeed = () => (
  <section className="icase-social" aria-labelledby="icase-social-title">
    <div className="icase-social-inner">
      <p className="section-eyebrow">STAY CONNECTED</p>
      <h2 id="icase-social-title">Social Feed</h2>
      <div className="icase-title-line" aria-hidden="true" />
      <div className="icase-facebook-wrap">
        <iframe
          title="ICAST Pakistan Facebook feed"
          src={facebookEmbed}
          width="500"
          height="620"
          scrolling="no"
          frameBorder="0"
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          loading="lazy"
        />
      </div>
      <a className="icase-facebook-link" href={facebookPage} target="_blank" rel="noopener noreferrer">
        View ICAST Pakistan on Facebook <span aria-hidden="true">→</span>
      </a>
    </div>
  </section>
);

export default ICASESocialFeed;
